module.exports = __webpack_public_path__ + "static/media/list_on.afc16718.svg";